export default "__VITE_ASSET__CrsMQB6z__"